import { render, staticRenderFns } from "./logistics-provider.vue?vue&type=template&id=670f21bf&scoped=true&"
import script from "./logistics-provider.vue?vue&type=script&lang=js&"
export * from "./logistics-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f21bf",
  null
  
)

export default component.exports